import { Tooltip } from '@ipfabric/ui-components/Tooltip/Tooltip';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import handleEvent from 'utils/handleEvent';

/**
 * Default frame that will be used with the widgets.
 */
const DefaultFrame = ({ children, onRemove, editable, title, msg }) => {
  const handleRemove = handleEvent(() => onRemove());
  return (
    <div className='defaultWidgetFrame'>
      <div className='defaultWidgetFrameHeader'>
        <span className='title'>{title}</span>
        {editable && (
          <Tooltip content={get(msg, ['dazzle', 'removeWidget'])}>
            {/* biome-ignore lint/a11y/useValidAnchor: legacy code, not worthy */}
            <a className='remove' onClick={handleRemove}>
              Remove
            </a>
          </Tooltip>
        )}
      </div>
      {children}
    </div>
  );
};

DefaultFrame.propTypes = {
  /**
   * Indicates weather the dashboard is in editable mode.
   */
  editable: PropTypes.bool,

  /**
   * Children of the frame.
   */
  children: PropTypes.node,

  /**
   * Function to call when the widget is removed.
   */
  onRemove: PropTypes.func,

  /**
   * Title of the widget
   */
  title: PropTypes.string,
  msg: PropTypes.object.isRequired,
};

export default DefaultFrame;
